import {Paragraph} from "@digdir/designsystemet-react";
import {Medal} from "@/components/athlete-overview-page/athlete-dialog/medal";
import {AthleteDialogAthleteProps,} from "@/components/athlete-overview-page/athlete-dialog/types";

export function AthleteStats(athlete: AthleteDialogAthleteProps) {

    const nameParts = athlete.athlete_name?.trim().split(" ") ?? [];
    const firstName = nameParts.slice(0, -1).join(" ");
    const lastName = nameParts.slice(-1)[0] ?? "";
    
    return (
        <div className="h-fit sm:h-full w-fit bg-main-base">
            <div className="h-fit sm:h-full w-full sm:overflow-x-auto">
                <div className="relative sm:z-50 w-full sm:w-[250px] xl:w-[450px] aspect-square">
                    <img src={athlete.athlete_image_url} alt={athlete.athlete_name}
                         className="size-full object-cover"/>
                </div>
                <div className="h-fit flex flex-col">
                    <div className="w-full h-fit flex flex-col gap-8 p-4 text-main-base-contrast">
                        <div className="flex flex-col">
                            <Paragraph data-size="md" className="!mb-0">{firstName}</Paragraph>
                            <Paragraph data-size="xl" className="!mb-0">{lastName}</Paragraph>
                            <Paragraph data-size="xs" className="!mb-0">{athlete.athlete_club}</Paragraph>
                        </div>
                        <Paragraph>
                            <span>{athlete.athlete_country}</span>
                            <span> (f. {athlete.athlete_birth_year})</span>
                        </Paragraph>
                        <div className="flex flex-col xl:flex-row  gap-2 items-end w-full ">
                            <div className="flex gap-2 items-end w-full ">
                                <div className="flex gap-2">
                                    <div className="flex flex-col gap-2 h-full justify-end items-center">
                                        <div className="text-black">
                                            <Medal rank={1}/>
                                        </div>
                                        <div
                                            className=" h-[100px] p-4 py-2 flex justify-end items-end  bg-brand-detail-blue-medium ">
                                            <Paragraph data-size="xl" className="!mb-0">
                                                {athlete.num_first_places}
                                            </Paragraph>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    <div className="flex flex-col gap-2 h-full justify-end items-center">
                                        <div className="text-black">
                                            <Medal rank={2}/>
                                        </div>
                                        <div
                                            className=" h-[80px] p-4 py-2 flex justify-end items-end border border-brand-detail-blue-medium   ">
                                            <Paragraph data-size="xl" className="!mb-0">
                                                {athlete.num_second_places}
                                            </Paragraph>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    <div className="flex flex-col gap-2 h-full justify-end items-center">
                                        <div className="text-black">
                                            <Medal rank={3}/>
                                        </div>            
                                        <div
                                            className=" h-[60px] p-4 py-2 flex justify-end items-end  bg-brand-detail-blue-medium ">
                                            <Paragraph data-size="xl" className="!mb-0">
                                                {athlete.num_third_places}
                                            </Paragraph>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full">
                                <Paragraph data-size={"sm"} className="!mb-0">Topp
                                    10: <b>{athlete.num_top_10}</b></Paragraph>
                                <Paragraph data-size={"sm"} className="!mb-0">Antall
                                    renn: <b>{athlete.num_events_started}</b></Paragraph>
                            </div>
                        </div>
                        <div>
                            <Paragraph className="flex flex-col gap-1 ">
                                <span>Sammenlagt: <b>{athlete.total_rank}. plass</b> ({athlete.total_points})</span>
                                <span>Distanse: <b>{athlete.total_rank_distance}. plass</b> ({athlete.total_points_distance})</span>
                                <span>Sprint: <b>{athlete.total_rank_sprint}. plass</b> ({athlete.total_points_sprint})</span>
                            </Paragraph>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}